import { CardStorageManager } from '../../shared/utils/CardStorageManager';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import React from 'react';
import DocumentaryLibraryCard from './DocumentaryLibraryCard';

export class DocumentaryLibraryScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.DOCUMENTARY_LIBRARY,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_BIBLIOTECA_DOCUMENTAL')} breadcrumbs={breadcrumbs}>
                <DocumentaryLibraryCard storageManager={this.cardStorageManager}/>
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('documentaryLibrary', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('documentaryLibrary');
    };
}

DocumentaryLibraryScreen.propTypes = {};

DocumentaryLibraryScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/DocumentaryLibraryScreen.jsx